export default {
    SET_CERTIFICATES_LOADING: 'SET_CERTIFICATES_LOADING',
    SET_SELECTED_CERTIFICATION: 'SET_SELECTED_CERTIFICATION',
    SET_SELECTED_USER: 'SET_SELECTED_USER',
    SET_MODE_CERTIFICATION_MODAL: 'SET_MODE_CERTIFICATION_MODAL',
    SET_SHOW_CERTIFICATION_MODAL: 'SET_SHOW_CERTIFICATION_MODAL',
    RESET_STATE: 'RESET_STATE',
};